import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useAudio from "../../../hooks/useAudio";


import bgGold from "../static/img/bg-gold.png";
import bgSilver from "../static/img/bg-silver.png";
import bgBronze from "../static/img/bg-bronze.png";

import { useTranslation } from "react-i18next";

const JackpotModal = ({ show, handleClose, userClass, jackpotAmount, currency }) => {
    const [animate, setAnimate] = useState(false);
    const [visible, setVisible] = useState(show);

    const { play, stop } = useAudio('/assets/sounds/winjackpotnew.mp3');

    const { t } = useTranslation();

    useEffect(() => {
        if (show) {
            play();
            setVisible(true);
            setTimeout(() => setAnimate(true), 200);
        } else {
            setAnimate(false);
            setTimeout(() => setVisible(false), 300);
        }
    }, [show]);

    if (!visible) return null;

    const getJackpotBackground = () => {
        switch (userClass) {
            case "gold":
                return "/assets/img/bg-gold.png";
            case "silver":
                return "/assets/img/bg-silver.png";
            case "bronze":
            default:
                return "/assets/img/bg-bronze.png";
        }
    };

    const closeModal = () => {
        stop();
        handleClose();
    };

    return (
        <>
            <div
                className={`modal fade jackpot_modal ${animate ? "show" : ""}`}
                id="jackpot_modal"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
            >
                <div className="modal-dialog" style={{ top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="body-jackpot">
                                <div className="img-background-jj">
                                    <img
                                        src={getJackpotBackground()}
                                        alt="Jackpot Background"
                                    />
                                </div>
                                <section className="header-jj">
                                    <div className="title-wrapper">
                                        <h1 className="jackpot-title-jj">
                                            <span
                                                className="title-jj"
                                                data-text="Jackpot"
                                            >
                                                {t("Jackpot")}
                                            </span>
                                            <span
                                                className={`${userClass}-jj`}
                                                data-text={
                                                    userClass
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                    userClass.slice(1)
                                                }
                                            >
                                                {userClass
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    userClass.slice(1)}
                                            </span>
                                        </h1>
                                    </div>
                                </section>
                                <div className="text-jackpot-win">
                                    <h1 id="jackpot-win">
                                        <small>{currency}</small>
                                        {jackpotAmount}
                                    </h1>
                                </div>
                                <div className="btn-close-jj">
                                    <a
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={closeModal}
                                    >
                                        {t("Get_reward")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Затемнення фону */}
            {visible && (
                <div
                    className={`modal-backdrop fade ${animate ? "show" : ""}`}
                    onClick={closeModal}
                ></div>
            )}
        </>
    );
};

JackpotModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    userClass: PropTypes.string.isRequired,
    jackpotAmount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
};

export default JackpotModal;
